module.exports = __webpack_public_path__ + "img/loading.8f0560d2.svg";